import { useMemo } from 'react';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseNavigationGlobalResourceReturn } from './types.tsx';

export const useNavigationGlobalResource = (): UseNavigationGlobalResourceReturn => {
	const { data, loading, error } = useResource(navigationSidebarGlobalResource);

	const response = useMemo(() => data && data.response, [data]);

	return { data: response, loading, error };
};
